import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { Redirect, useLocation, withRouter } from "react-router";
import UserContext from "../../context/UserContext";
import "./Navbar.css";
import { push as Menu } from "react-burger-menu";
import { useMediaQuery } from "react-responsive";
import config from "../../config/apiConfig";
import logo from "../../icons/logo.jpg";
import { Link, NavLink } from "react-router-dom";
import {
    Search,
    Close,
    Edit,
    RemoveRedEye,
    PowerSettingsNew,
    HighlightOff,
    CloudUpload,
} from "@material-ui/icons";
import { propTypes } from "react-bootstrap/esm/Image";
import { getInfo } from "../../utils/hooks";
import black from "../../icons/default1.png";
import ReactGA from "react-ga";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Navbar(props) {
    const [loggedIn, setLoggedIn] = useState(true);
    const [user, setUser] = useContext(UserContext);
    const [scrapbook, setScrapbook] = useState({});
    const [isScrapbookLoading, setIsScrapbookLoading] = useState(false);
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
    const [query, setQuery] = useState("");
    const q = useQuery().get("query");

    function handleSearch(e) {
        if (query != "") {
            ReactGA.event({
                category: "Search",
                action: "Search query = " + query,
            });
            const win = window.open(
                Cookies.get("admin")
                    ? "/admin"
                    : "/writer" + "/search?query=" + query,
                "_self"
            );
        }
    }

    useEffect(() => {
        if (Cookies.get("token") === undefined) {
            setLoggedIn(false);
        }
    }, []);
    useEffect(() => {
        if (props.scrapbook) {
            setScrapbook(props.scrapbook);
        }
    }, [props.scrapbook]);
    function handleLogout(e) {
        e.preventDefault();
        Cookies.remove("token");
        Cookies.remove("id");
        Cookies.remove("info");
        Cookies.remove("current_filter");
        Cookies.remove("admin");
        Cookies.remove("auth_token");
        window.location.replace(
            "http://13.235.209.150/auth?token=&redirect_url=http://13.235.209.150/login&gr=logout"
        );
    }
    function handleNoImage(e) {
        e.target.src = black;
    }
    function handleScrapbook(e) {
        e.preventDefault();
        const ele = document.querySelector(".scrapbook__container");
        if (ele.style.display == "none") {
            const formData = new FormData();
            formData.append("session-token", Cookies.get("token"));
            formData.append("token", config.token);
            const requestOptions = {
                method: "POST",
                body: formData,
            };
            fetch(
                config.BASE_URL + "/v1/get/scrapbook/stories?climit=100",
                requestOptions
            )
                .then((response) => response.json())
                .then((resp) => {
                    setScrapbook(resp);
                    setIsScrapbookLoading(false);
                    console.log(resp);
                })
                .catch((err) => console.log(err));
            ele.style.display = "flex";
        } else {
            ele.style.display = "none";
        }
    }
    function handleDrop(e) {
        document.getElementById(e.target.name).classList.toggle("dshow");
    }
    function handleDeleteFromScrap(id) {
        ReactGA.event({
            category: "Scrapbook",
            action: "Delete from scrapbook",
            label: id,
        });

        const formData = new FormData();
        formData.append("session-token", Cookies.get("token"));
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(
            config.BASE_URL + "/v1/put/scrapbook/delete?story_id=" + id,
            requestOptions
        )
            .then((response) => response.json())
            .then(() => {
                const data = [...scrapbook.data];
                const newData = data.filter((story) => story.id !== id);
                const newScrapbook = { ...scrapbook, data: newData };
                setScrapbook(newScrapbook);
                if (props.deleteScrap) {
                    props.deleteScrap(id);
                }
            });
    }

    /**
     *
     * @param {import("../../utils/hooks").Role} role
     * @returns
     */
    const handleRoleChange = (role) => {
        if (!role.approved) {
            alert("Your application is being reviewed. Please wait for your approval.");
            return;
        }
        if (role.name === "pencil_writer") {
            window.location.replace(
                `http://13.235.209.150/auth?token=${Cookies.get(
                    "auth_token"
                )}&redirect_url=http://13.235.209.150/dashboard&gr=pencil_writer`
            );
        }
        const formData = new FormData();
        formData.append("auth_token", Cookies.get("auth_token"));
        formData.append("gr", role.name);
        formData.append("token", config.token);
        formData.append("session-token", "AUTH");
        formData.append("device", "web");
        formData.append("user_ip", "120.12.22.130");
        formData.append("user_agent", "Mozilla 1");
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/idam/user/sso_login", requestOptions)
            .then((response) => response.json())
            .then((resp) => {
                if (resp.is_error) {
                    return;
                } else {
                    Cookies.set("info", JSON.stringify(resp.data.user_info));
                    ReactGA.event({
                        category: "AUTH",
                        action: "Dashboard changed to " + role.label,
                        label: resp.data.user_id,
                    });
                    window.location.reload();
                }
            });
    };

    return loggedIn ? (
        isTabletOrMobile ? (
            <Menu pageWrapId={"main"} outerContainerId={"outer-container"}>
                <div className="navbar__left" style={{ display: "flex" }}>
                    <Link to="/">
                        <img style={{ height: 32 }} src={logo} alt="" />
                    </Link>
                </div>
                <a
                    className="navbar__link__active"
                    style={{ margin: "40px 0" }}
                >
                    Discover
                </a>
                <a
                    className="navbar__link"
                    style={{ margin: "40px 0" }}
                    onClick={handleScrapbook}
                >
                    Scrapbook
                </a>
                <a className="navbar__link" style={{ margin: "40px 0" }}>
                    Your Stories
                </a>
            </Menu>
        ) : (
            <div className="navbar">
                <div
                    className="scrapbook__container"
                    style={{ display: "none" }}
                >
                    <div
                        className="scrapbook__top"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <div>
                            <h4 style={{ fontWeight: "800", fontSize: "16px" }}>
                                Your Scrapbook ({scrapbook?.data?.length}{" "}
                                stories)
                            </h4>
                        </div>

                        <div onClick={handleScrapbook} className="close__btn">
                            <Close style={{ pointerEvents: "none" }} />
                        </div>
                    </div>
                    <div id="scrap__line"></div>
                    <div className="scrapbook__list">
                        {scrapbook?.data?.map((story) => (
                            <div
                                className="scrap__container"
                                onClick={() => {
                                    ReactGA.event({
                                        category: "Scrapbook",
                                        action: "Scrapbook click",
                                        label: story.id,
                                    });
                                    const win = window.open(
                                        `/writer/story/${story.id}`,
                                        "_blank"
                                    );
                                    win.focus();
                                }}
                            >
                                <div className="scrap__left">
                                    <img
                                        className="scrap__img"
                                        src={story?.images[0]?.link ?? ""}
                                        onError={handleNoImage}
                                    />
                                </div>
                                <div className="scrap__right">
                                    <h4 className="scrap__title">
                                        {story.title}
                                    </h4>
                                    <div className="scrap__delete">
                                        <HighlightOff
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteFromScrap(story.id);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <Link
                        to={"/writer/write"}
                        className="write__btn"
                        style={{ left: "16px" }}
                        onClick={() =>
                            ReactGA.event({
                                category: "Scrapbook",
                                action: "Start writing",
                            })
                        }
                    >
                        Start writing
                    </Link>
                </div>
                <div className="navbar__left">
                    <Link to="/">
                        <img style={{ height: 32 }} src={logo} alt="" />
                    </Link>
                    <div className="navbar__links">
                        <NavLink
                            to="/writer"
                            className="navbar__link"
                            activeClassName="active"
                        >
                            Discover
                        </NavLink>
                        <a className="navbar__link" onClick={handleScrapbook}>
                            Scrapbook
                        </a>
                        <NavLink
                            to="/writer/story/my"
                            className="navbar__link"
                            activeClassName="active"
                        >
                            Your Stories
                        </NavLink>
                    </div>
                </div>
                <div className="navbar__right navbar__right__main">
                    <input
                        type="text"
                        className="navbar__input"
                        placeholder={"Search"}
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <Search onClick={handleSearch} />
                    <input type="submit" style={{ display: "none" }}></input>
                    <div className="dropdown">
                        <button
                            onClick={(e) => handleDrop(e)}
                            className="primary__btn"
                            style={{ marginLeft: "20px", marginBottom: "0" }}
                            name="ddwrite"
                        >
                            Write
                        </button>
                        <div className="dropdown-wrapper pt_0" id="ddwrite">
                            <div className="dropdown-content">
                                <ul>
                                    <li
                                        className="write"
                                        onClick={() =>
                                            props.history.push("/writer/write")
                                        }
                                    >
                                        <Edit
                                            style={{
                                                height: "18px",
                                                width: "18px",
                                            }}
                                        />
                                        <span style={{ paddingLeft: 4 }}>
                                            Write a new story
                                        </span>
                                    </li>
                                    {/* <li
                                        className="write"
                                        onClick={() =>
                                            props.history.push(
                                                "/writer/upload"
                                            )
                                        }
                                    >
                                        <CloudUpload
                                            style={{
                                                height: "18px",
                                                width: "18px",
                                            }}
                                        />
                                        <span style={{ paddingLeft: 4 }}>
                                            Upload new story
                                        </span>
                                    </li> */}
                                    <li
                                        className="write"
                                        onClick={() =>
                                            props.history.push(
                                                "/writer/story/my"
                                            )
                                        }
                                    >
                                        <RemoveRedEye
                                            style={{
                                                height: "18px",
                                                width: "18px",
                                            }}
                                        />
                                        <span style={{ paddingLeft: 4 }}>
                                            View your stories
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* <button className="navbar__logout" onClick={handleLogout}>Logout</button> */}
                    <div className="navbar__profile">
                        <div className="dropdown">
                            <button
                                onClick={(e) => handleDrop(e)}
                                className="navbar__img"
                                name="dprofile"
                            ></button>
                            <div
                                className="dropdown-wrapper pt_0"
                                id="dprofile"
                            >
                                <div className="dropdown-content">
                                    <ul>
                                        {getInfo()?.roles?.map((role) => (
                                            <li
                                                key={role.global_role_id}
                                                onClick={() =>
                                                    handleRoleChange(role)
                                                }
                                                className="write"
                                            >
                                                {role.label} Dashboard
                                            </li>
                                        ))}
                                        <li
                                            className="write"
                                            onClick={(e) => handleLogout(e)}
                                        >
                                            <PowerSettingsNew
                                                style={{
                                                    height: "18px",
                                                    width: "18px",
                                                }}
                                            />
                                            <span style={{ paddingLeft: 4 }}>
                                                Log Out
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <h2 className="small__heading">
                            {getInfo()?.name ?? "User"}
                        </h2>
                    </div>
                </div>
            </div>
        )
    ) : (
        <Redirect to="/login" />
    );
}

export default withRouter(Navbar);
